import { CSSProperties } from "react";

export const XFactionPointSvg = ({
  darkColor,
  lightColor,
  style = {},
}: {
  darkColor: string;
  lightColor: string;
  style?: CSSProperties;
}) => {
  const gradientId = `paint_${darkColor}`;
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={style}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <circle
        cx="24"
        cy="24"
        r="23.5"
        stroke={lightColor}
        strokeOpacity="0.13"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="24"
          y1="0"
          x2="24"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={lightColor} />
          <stop offset="1" stopColor={darkColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};
